import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import {
  BookingApiService,
  //   BookingsResponse,
  GetBookingsParams,
  //   SourceResponse,
} from "features/bookings";

import { bookingsQueryKeys } from "./query-keys";

const { getSourceBooking } = BookingApiService();

const getBookingsQuery = (
  params: GetBookingsParams,
  options?: UseQueryOptions<any>
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: bookingsQueryKeys.list(params),
  queryFn: ({ signal }) => getSourceBooking(params, { config: { signal } }),
  ...options,
});

export const useSourceBookings = (
  params: GetBookingsParams,
  options?: UseQueryOptions<any>
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getBookingsQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    })
  );
};
